/**
 * PuzzleService — Client-side Puzzle-Logik für Solo-Modus.
 *
 * WARUM Client-side: Solo-Modus muss offline funktionieren (PWA).
 * Multiplayer-Puzzle kommen vom Server (siehe lobbyService).
 */
import { getRandomPuzzle, getPuzzleByDifficulty } from '../data/puzzles/index.js';

class PuzzleService {
  constructor() {
    this.currentPuzzle = null;
    this.startTime = null;
    this.usedHint = false;
    this.streak = 0;
    this.score = 0;
  }

  nextPuzzle(difficulty = null) {
    this.currentPuzzle = difficulty
      ? getPuzzleByDifficulty(difficulty)
      : getRandomPuzzle();
    this.startTime = Date.now();
    this.usedHint = false;
    return this.currentPuzzle;
  }

  // Normalisierung wie auf Server — Eingabe robust vergleichen
  validate(userAnswer) {
    if (!this.currentPuzzle) return { correct: false };

    const normalize = (s) => String(s ?? '').trim().toLowerCase().replace(/\.0+$/, '');
    const user = normalize(userAnswer);
    const real = normalize(this.currentPuzzle.a);
    const correct = user === real;
    const timeMs = Date.now() - this.startTime;

    if (correct) {
      this.streak++;
      this.score += this.calculatePoints(timeMs);
    } else {
      this.streak = 0;
    }

    return {
      correct, timeMs,
      points: correct ? this.calculatePoints(timeMs) : 0,
      explanation: this.currentPuzzle.exp,
      correctAnswer: this.currentPuzzle.a,
    };
  }

  // Selbe Formel-Idee wie Server, vereinfacht für Solo
  calculatePoints(timeMs) {
    const seconds = timeMs / 1000;
    const base = 1000 - Math.floor(seconds * 15);
    const hintPenalty = this.usedHint ? -100 : 0;
    return Math.max(100, base + hintPenalty);
  }

  revealHint() {
    if (!this.currentPuzzle) return null;
    this.usedHint = true;
    return this.currentPuzzle.hint;
  }

  resetSession() {
    this.score = 0;
    this.streak = 0;
    this.currentPuzzle = null;
  }

  getSessionStats() {
    return { score: this.score, streak: this.streak };
  }
}

export const puzzleService = new PuzzleService();
